import React from 'react';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import { AppContent } from '@common/components';
import { SchedulePeriodsTable } from '@load-balancing/components/schedule-periods-table';

export function ScheduleDashboardPage() {
  useSetBreadcrumbs([
    {
      name: 'Schedule',
      path: '/works/schedule',
    },
    {
      name: 'Dashboard',
      path: '/works/schedule/dashboard',
    },
  ]);

  return (
    <AppContent>
      <SchedulePeriodsTable />
    </AppContent>
  );
}
